module.exports = __webpack_public_path__ + "img/box.f2eadb35.png";